import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "./context/context";
import { SpeechProvider } from "@speechly/react-client";
import App from "./App";
import "./styles.css";
ReactDOM.render(
  <SpeechProvider appId="b8fa6b4a-829b-4a97-8a01-bbf87d8e29d5" language="en-US">
    <Provider>
      <App />
    </Provider>
  </SpeechProvider>,
  document.getElementById("root")
);
